import InputComponent from "V2.0/components/InputComponent";

export default MinConversationTurn;

function MinConversationTurn(props) {
  const { coachTriggerState, setCoachTriggerState, isUnlocked } = props;

  const handleChange = function (e) {
    const value = Number(e.target.value);

    setCoachTriggerState((prev) => {
      return {
        ...prev,
        minConversationTurns: value,
      };
    });
  };

  return (
    <div>
      <InputComponent
        min={0}
        type="number"
        disabled={!isUnlocked}
        value={coachTriggerState.minConversationTurns}
        name="minConversationTurns"
        label="Minimum Conversation Turns"
        onChange={handleChange}
      />
    </div>
  );
}
